import { render } from "./SupportPopup.vue?vue&type=template&id=2172df68"
import script from "./SupportPopup.vue?vue&type=script&lang=js"
export * from "./SupportPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__